import React, { Component } from 'react'
import { Answer } from 'components/answer'
import './QuestionDemography.css'

export class QuestionDemography extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedAnswer: this.props.answer ? Number(this.props.answer) : null,
      showResuts: !!this.props.answer
    }
    this.handler = this.handler.bind(this)
  }

  handler(id) {
    if (!this.state.selectedAnswer) {
      this.setState({
        selectedAnswer: id
      })
      setTimeout(() => {
        this.setState({ showResuts: true })
      }, 500)
      this.props.onAnswered(this.props.id, id, this.props.next)
    }
  }

  render() {
    return (
      <div
        className={
          'demography question' + (this.state.showResuts ? ' answered' : '')
        }
      >
        <div className='header'>
          <h2>{this.props.title}</h2>
          <div className='answers'>
            {this.props.answers.map((answer, index) => {
              return (
                <Answer
                  key={index}
                  id={index}
                  label={answer}
                  faded={
                    !(
                      this.state.selectedAnswer === index ||
                      this.state.selectedAnswer === null
                    )
                  }
                  handleChange={this.handler}
                />
              )
            }, this)}
          </div>
          <div className='question-number'>
            <div>Continuez</div>
            <i className='ui icon chevron down' />
          </div>
        </div>
      </div>
    )
  }
}
